//===================================
// Post list
//===================================

import { postFilters, postListing } from '../includes/post-list';      
import multiCheckboxInput from '../includes/multi-checkbox-input'; 
import { SplideGallery } from "../includes/splide";

const PostList = (ele) => {
  SplideGallery('.post-list .splide', {
    type: 'loop',
    autoplay: true,
    interval: 5000,
    arrows: false,
    pagination: true,
    classes: {
      pagination: 'splide__pagination container absolute bottom-0 justify-start gap-2 left-1/2 -translate-x-1/2 pb-12 lg:pb-24',
      page      : 'splide__pagination__page rounded-full bg-white w-3 aspect-square hover:bg-highlight [&.is-active]:bg-highlight transition-colors',
    },
  });
  
  const subheadHtml = ({ _embedded, published_at }) => {
    const categories = _embedded ? _embedded['wp:term'][0] : [];
    let subhead = '';

    subhead += published_at;

    if (categories) {
      subhead += ` <span class="opacity-40">${categories[0].name}</span>`;
    }

    return subhead;
  }

  const smallPostHtml = (post) => {
    const subhead = subheadHtml(post);

    const {
      title,
      link,
      featured_image
    } = post;

    return `
      <div class="col post-tile relative md:col-span-6 lg:col-span-3">
        <div class="image w-full aspect-[4/3] bg-black-400 mb-6"><img src="${featured_image.medium}" class="object-cover object-center w-full h-full"></div>
        <div class="copy-block">
          <p class="subhead m-0">${subhead}</p>
          <h4 class="mt-2"><span class="mys-arrow inline-block"></span>${title.rendered}</h4>
        </div>
        <a href="${link}" class="absolute inset-0 z-10"><span class="sr-only">Read more about ${title.rendered}</span></a>
      </div>
    `;
  } 

  const mediumPostHtml = (post) => {
    const subhead = subheadHtml(post);

    const {
      title,
      link,
      featured_image
    } = post;

    return `
      <div class="col post-tile relative md:col-span-6">
        <div class="image w-full aspect-[4/3] bg-black-400 mb-6"><img src="${featured_image.large}" class="object-cover object-center w-full h-full"></div>
        <div class="flex gap-2 flex-col lg:flex-row">
          <div class="w-48 copy-block flex flex-col gap-2 justify-between shrink-0">
            <p class="subhead m-0">${subhead}</p>
            <div class="mys-arrow !w-8 hidden lg:block"></div>
          </div>
          <div class="copy-block"> 
            <h4><span class="mys-arrow inline-block lg:hidden"></span>${title.rendered}</h4>
          </div>
        </div>
        <a href="${link}" class="absolute inset-0 z-10"><span class="sr-only">Read more about ${title.rendered}</span></a>
      </div>
    `;
  }

  const largePostHtml = (post) => {
    const subhead = subheadHtml(post);

    const {
      title,
      link,
      featured_image
    } = post;

    return `
      <div class="col aspect-[5/3] w-full min-h-[35rem] flex items-end py-6 lg:py-12 relative">
        <div class="absolute inset-0">
          <img src="${featured_image.large}" class="object-cover object-center w-full h-full">
          <div class="film absolute bg-black/50 inset-0"></div>
        </div>
        <div class="container relative">
          <div class="row">
            <div class="col md:col-span-6 md:col-start-7">
              <div class="copy-block text-white">
                <p class="subhead m-0">${subhead}</p>
                <h2>${title.rendered}</h2>
                <a href="${link}" class="button text-white">
                  <span class="button-bg"></span>
                  <span class="button-text">Read more</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a href="${link}" class="absolute inset-0 z-10"><span class="sr-only">Read more about ${title.rendered}</span></a>
      </div>
    `;
  }

  const postHtml = (post, {index}) => {
    const patternIndex = index % 9;

    if (patternIndex == 0) return largePostHtml(post);
    if ([1,4,5,8].includes(patternIndex)) return mediumPostHtml(post);
    return smallPostHtml(post);
  }

  const buildQueryUrl = ({ search, categories, page }) => {
    const url = new URL(`${window.location.origin}/wp-json/wp/v2/posts`);
    categories && categories.length && url.searchParams.set('categories', categories.join(','));
    search && url.searchParams.set('search', search);

    url.searchParams.set('page', page);
    url.searchParams.set('per_page', 9);
    url.searchParams.set('_embed', 1);

    return url;
  }

  const { getQuery, setQuery } = postFilters({
    queryChangeEvent: 'postQueryChange',
    fields: ['categories'],
    arrayFields: ['categories'],
  });

  const initialQuery = getQuery();

  postListing(ele, {
    buildQueryUrl,
    postHtml,
    queryChangeEvent: 'postQueryChange',
    initialQuery,
    perPage: 9
  });

  const filters = () => {
    const categories = document.querySelectorAll('input[name="categories"]');

    const onChange = ({name, value}) => {
      const query = getQuery();

      setQuery({ ...query, [name]: value });
    }

    multiCheckboxInput(categories, {
      initialValue: initialQuery.categories,
      onChange
    });
  }

  filters();
}

document.addEventListener('DOMContentLoaded', () => {
  const ele = document.querySelector('.post-list');

  if (ele) PostList(ele);
});
